export default "__VITE_ASSET__a18dd435__"